import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { Divider } from './Divider';
export function MethodIntro() {
  const features = ['Reflexión guiada.', 'Escritura terapéutica.', 'Visualización bíblica.', 'Gratitud diaria.', 'Liberación emocional.', 'Acción inspirada.'];
  return <section className="w-full bg-[#F7F2E7] py-20 px-6" data-id="element-159" data-mp="20kyrvj5f4z6h">
      <div className="max-w-4xl mx-auto text-center" data-id="element-160" data-mp="25mxtanhllm0s">
        <motion.p initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-base md:text-lg font-semibold uppercase tracking-wide text-[#0A1535] mb-6" style={{
        color: "#0A1535"
      }} data-id="element-161" data-mp="25kbo2ui6jilq">
          Eso es exactamente lo que fue diseñado para ayudarte a lograr
        </motion.p>

        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-5xl md:text-6xl font-bold text-[#C9A24B] mb-4" style={{
        fontSize: "56px"
      }} data-id="element-162" data-mp="2oe8kl5r8k0t7">
          MÉTODO R.E.V.E.L.A.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-2xl md:text-3xl text-[#0A1535] mb-8" style={{
        fontSize: "24px"
      }} data-id="element-163" data-mp="3q0pxkuzbjvz0">
          30 Días con Dios para Vivir en Abundancia desde la Fe
        </motion.p>

        <Divider data-id="element-164" data-mp="cnd3lig46br2" />

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-lg md:text-xl text-[#0A1535] mb-8 leading-relaxed" data-id="element-165" data-mp="cmuzjzn7mt8l">
          Un programa práctico y profundamente espiritual que combina:
        </motion.p>

        <div className="grid md:grid-cols-2 gap-4 mb-12 max-w-2xl mx-auto" data-id="element-166" data-mp="2ptkum5wjilhe">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-center gap-3 text-left" data-id="element-167" data-mp="2tuwm6gyz5gs8" data-mpi={index}>
              <CheckCircle2 className="w-6 h-6 text-[#C9A24B] flex-shrink-0" data-id="element-168" data-mp="1x6qbbcbgls5i" />
              <span className="text-lg text-[#0A1535]" data-id="element-169" data-mp="2259yth5pbbzz">{feature}</span>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-lg md:text-xl text-[#0A1535] leading-relaxed" data-id="element-170" data-mp="3rjpxxpe9bmma">
          Todo dentro de un proceso sencillo de 30 días — solo{' '}
          <span className="font-bold text-[#C9A24B]" data-id="element-171" data-mp="eins7xm6z43h">
            10 a 15 minutos cada día
          </span>{' '}
          — que te ayudará a fortalecer tu relación con Dios mientras
          desarrollas hábitos que transforman tu manera de pensar, sentir y
          vivir.
        </motion.p>
      </div>
    </section>;
}